import React, { ReactNode, useCallback, useState } from 'react';
import { Portal } from '@mui/material';
import { ToastContext } from './Toast.context';
import { Toast, ToastProps } from '../Toast';

export function ToastProvider({ children }: { children?: ReactNode }) {
  const [toastProps, toggleToast] = useState<ToastProps | null>(null);
  const onClose = useCallback(() => {
    toggleToast(null);
  }, [toggleToast]);

  return (
    <ToastContext.Provider value={{ toastProps, toggleToast }}>
      {children}
      {toastProps ? (
        <Portal>
          <Toast {...toastProps} onClose={onClose} />
        </Portal>
      ) : null}
    </ToastContext.Provider>
  );
}
